var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.comment)?_c('div',{staticClass:"evaluation-viewer-comment"},[_c('h6',[_vm._v("COMENTARIO")]),_vm._v(" "),_c('main',{domProps:{"innerHTML":_vm._s(_vm.comment)}})]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d4baae7e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/evaluation-viewer/components/evaluation-viewer-comment.vue
// module id = null
// module chunks = 